var map = {
	"./contact-widget/close.svg": "93fe",
	"./contact-widget/contact-form.svg": "160c",
	"./contact-widget/messenger.svg": "48d2",
	"./contact-widget/open-contact.svg": "cd65",
	"./contact-widget/phone.svg": "f203",
	"./contact-widget/viber.svg": "466b",
	"./feature-list/adminuser.svg": "1993",
	"./feature-list/analytics.svg": "ae54",
	"./feature-list/animation.svg": "9fec",
	"./feature-list/api.svg": "8dd1",
	"./feature-list/contactform.svg": "286f",
	"./feature-list/customizedfeatures.svg": "8ce3",
	"./feature-list/database.svg": "41a3",
	"./feature-list/favicon.svg": "c493",
	"./feature-list/filters.svg": "0395",
	"./feature-list/gallery.svg": "3bdc",
	"./feature-list/hostingdomain.svg": "e8b7",
	"./feature-list/languages.svg": "8204",
	"./feature-list/lazyload.svg": "d31f",
	"./feature-list/mailsetup.svg": "8b8d",
	"./feature-list/maps.svg": "5c69",
	"./feature-list/menu.svg": "1680",
	"./feature-list/pwa.svg": "bb2c",
	"./feature-list/responsive.svg": "0ac7",
	"./feature-list/search.svg": "f79a",
	"./feature-list/seo.svg": "2f9b",
	"./feature-list/ssl.svg": "cf15",
	"./feature-list/themes.svg": "398e",
	"./feature-list/validation.svg": "0935",
	"./footer/email.svg": "0b57",
	"./footer/facebook.svg": "d0f2",
	"./footer/phone.svg": "e8b4",
	"./footer/terms.svg": "ee30",
	"./logo.svg": "8e9e",
	"./menu.svg": "06aa",
	"./notifications/error.svg": "a8cd",
	"./notifications/success.svg": "37c5",
	"./price-tag.svg": "e538b",
	"./wemake/graphic-design.svg": "4c6b",
	"./wemake/web-design.svg": "60ac",
	"./wemake/web-development.svg": "9a5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcb7";